import { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { SmallLightGrayButton, SmallOrangeButton } from '../Layout/CommonStyle'

type Props = {
  initialValue: string
  initialEditMode: boolean
  placeholder?: string
  setValue: (v: string) => void
  height?: string
}

function TextAreaDiv(props: Props) {
  const [initialValue, setInitialValue] = useState<string>(props.initialValue)
  const [text, setText] = useState<string>(props.initialValue)
  const [isEditMode, setIsEditMode] = useState<boolean>(props.initialEditMode)

  const memoInput = useRef<HTMLTextAreaElement>(null)

  const onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { value } = e.target
    setText(value)
  }

  const onClickMemoArea = () => {
    setIsEditMode(true)
  }

  const onClickSave = () => {
    props.setValue(text)
    setInitialValue(text)
    setIsEditMode(false)
  }

  const onClickCancel = () => {
    setText(initialValue)
    setIsEditMode(false)
  }

  useEffect(() => {
    if (isEditMode) {
      memoInput.current?.focus()
      memoInput.current?.select()
      const end = memoInput.current?.selectionEnd ?? 0
      memoInput.current?.setSelectionRange(end, end)
    }
  }, [isEditMode])

  return (
    <Container>
      {isEditMode ? (
        <>
          <Textarea
            value={text}
            placeholder={props.placeholder ?? ''}
            onChange={onChange}
            ref={memoInput}
            height={props.height}
          ></Textarea>
          <SmallOrangeButton onClick={() => onClickSave()}>
            저장
          </SmallOrangeButton>
          <SmallLightGrayButton onClick={() => onClickCancel()}>
            취소
          </SmallLightGrayButton>
        </>
      ) : (
        <Box height={props.height} onClick={() => onClickMemoArea()}>
          <pre>{text}</pre>
        </Box>
      )}
    </Container>
  )
}

const Container = styled.div``

const Box = styled.div<{ height: string | undefined }>`
  border: 1px solid #ddd;
  height: ${(props) => (props.height ? props.height : '80px')};
  padding: 0 10px;
  color: #666;
  background-color: #f9f9f9;
`

const Textarea = styled.textarea<{ height: string | undefined }>`
  width: 100%;
  height: ${(props) => (props.height ? props.height : '80px')};
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #bbb;
`

export default TextAreaDiv
